import React from 'react'
import { FaEnvelope, FaBuilding } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import {
  COMPANY_ADDRESS,
  COMPANY_CITY,
  COMPANY_EMAIL,
  COMPANY_NAME,
  COMPANY_TVA,
} from '../../services/api'
import { FaLocationDot } from 'react-icons/fa6'
import { MdHelp } from 'react-icons/md'

interface CompanyInfoModalContentProps {
  onClose: () => void
  title?: string
}

const CompanyInfoModalContent: React.FC<CompanyInfoModalContentProps> = ({
  title = 'contact-us',
}) => {
  const { t } = useTranslation()

  const companyEmail = COMPANY_EMAIL

  return (
    <div className='flex flex-col h-full rounded-lg overflow-hidden'>
      <h2 className='text-base sm:text-lg lg:text-xl  bg-anthracite text-white px-4 py-2 lg:py-2 '>
        {t(title)}
      </h2>

      <div className='space-y-4 text-left text-anthracite p-6 flex-grow'>
        {/*
        <div className='flex items-start gap-3'>
          <FaBuilding className='mt-1 text-redpink mr-1' />
          <div>
            <p className='font-semibold'>{t('company')}</p>
            <p>{COMPANY_NAME}</p>
          </div>
        </div>
        */}

        <div className='flex items-start gap-3'>
          <FaEnvelope className='mt-1 text-redpink mr-1' />
          <div>
            <p className='font-semibold'>Email</p>
            <a
              href={`mailto:${companyEmail}`}
              className='text-redpink hover:text-anthracite transition-colors'
              onClick={e => {
                e.stopPropagation()
              }}
            >
              {companyEmail}
            </a>
          </div>
        </div>

        <div className='flex items-start gap-3'>
          <FaLocationDot className='mt-1 text-redpink mr-1' />
          <div>
            <p className='font-semibold'>{t('address')}</p>
            <p>{COMPANY_ADDRESS}</p>
            <p>{COMPANY_CITY}</p>
          </div>
        </div>

        <div className='flex items-start gap-3'>
          <MdHelp className='mt-1 text-redpink text-xl' />
          <div>
            <p className='font-semibold'>{t('support')}</p>
            <p>{t('support-hours')}</p>
          </div>
        </div>
      </div>
      {/*
      <div className='p-3 bg-grisclair2'>
        <p className='text-anthracite text-center'>
          <b>{t('vat')}:</b> {COMPANY_TVA}
        </p>
      </div>
       */}
    </div>
  )
}

export default CompanyInfoModalContent
